import React from 'react';
import './Tube.css';

function Tube({ items, isSelected, onClick }) {
  return (
    <div 
      className={`tube ${isSelected ? 'selected' : ''}`} 
      onClick={onClick}
    >
      {items.map((item, index) => (
        <div key={index} className={`ball ball-${item}`} />
      ))}
    </div>
  );
}

export default Tube;
